module.exports = __webpack_public_path__ + "static/media/waterSoda.016ca75f.webp";